import React, { Component } from 'react';
import { toast } from "react-toastify";
import { Button, Form, Modal } from 'react-bootstrap';
import AddSharpIcon from "@material-ui/icons/AddSharp";
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

import OTP from '../../otp/otp';
import axios from '../../../axios';
import apiError from '../../../error';
import Loader from '../../loader/loader';
import CountdownTimer from '../../count-down-timer/count-down-timer';

export default class AttackProfileTelegram extends Component {

    componentDidMount() {
        this.load();
    }

    state = {
        phone: this.props.phone || '',
        otp: '',
        otpSent: false,
        otpVerified: false,
        loading: false,
        verifyingOtp: false,
        twoFaPassword: '',
        telegramId: this.props.telegramId || '',
        otpExpirationTimeRemaining: 0,
        showNumberModal: false
    };

    componentDidUpdate(prevProps) {
        if (prevProps.phone !== this.props.phone) {
            this.setState({ phone: this.props.phone });
        }
        if (prevProps.telegramId !== this.props.telegramId) {
            this.setState({ telegramId: this.props.telegramId });
        }
    }

    handleShow = () => this.setState({ showNumberModal: true });

    numberhandleClose = () => {
        this.setState({
            showNumberModal: false,
            phone: '',
            otpSent: false,
            otpVerified: false,
            telegramId: ''
        });
    };

    handleRequestOTP = async () => {
        const { phone } = this.state;
        if (!phone || phone.length < 8) {
            toast.error("Please enter a valid Telegram number");
            return;
        }

        this.setState({ loading: true });
        try {
            const res = await axios.post('/api/telegram/request-otp', { phone });
            this.setState({
                otpSent: true,
                loading: false,
                otpExpirationTimeRemaining: res.data.otpExpirationTimeRemaining || 60
            });
            toast.success(res.data.message);
        } catch (error) {
            this.setState({ loading: false });
            const errMsg = error.response?.data?.errors?.[0] || '';
            if (errMsg.startsWith("OTP_SENT_")) {
                const remainingTime = parseInt(errMsg.split('_')[2]) || 60;
                this.setState({ otpSent: true, otpExpirationTimeRemaining: remainingTime });
                toast.info("OTP has already been sent");
            } else {
                apiError(error);
            }
        }
    };

    load = () => {
        if (this.props.senderId) {
            axios.get('/api/senders/' + this.props.senderId, {})
                .then(async res => {
                    if (res.data.sender && res.data.sender.telegram) {
                        this.setState({ 
                            telegramId: res.data.sender.telegramId,
                            phone: res.data.sender.telegram.phone || ''
                        })
                    }
                })
                .catch(error => apiError(error))
        }
    }

    handleVerifyOTP = async () => {
        const { phone, otp, twoFaPassword } = this.state;
        if (!otp || otp.length < 4) {
            toast.error("Please enter a valid OTP");
            return;
        }

        this.setState({ verifyingOtp: true });
        try {
            const res = await axios.post('/api/telegram/sign-in', { phone, otp, twoFaPassword });
            const telegramId = res.data.telegramId;
            this.setState({
                otpVerified: true,
                otpSent: false,
                telegramId,
                verifyingOtp: false
            });
            this.numberhandleClose();
            this.handleCreateSender(telegramId);
            toast.success("Number verified successfully");
        } catch (error) {
            this.setState({ verifyingOtp: false });
            apiError(error);
        }
    };

    handleCreateSender = async (telegramId = this.state.telegramId) => {
        if (!telegramId) {
            toast.error("Some error occurred while logging to telegram, please try again later");
            return;
        }

        this.setState({ loading: true });
        const payload = {
            telegramId,
            campaignTemplateId: this.props.campaignTemplateId
        };

        const request = this.props.senderId
            ? axios.patch(`/api/senders/telegram/${this.props.senderId}`, payload)
            : axios.post('/api/senders/telegram', payload);

        try {
            const res = await request;
            this.setState({ loading: false });
            this.props.handleSenderId(res.data.sender.id);
            this.props.handleTabChange('next');
            toast.success('Telegram Attack Profile Saved');
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    };

    handleOTP = otp => this.setState({ otp });

    decreaseOtpExpirationTime = () => {
        this.setState(prevState => {
            const time = prevState.otpExpirationTimeRemaining - 1;
            return {
                otpExpirationTimeRemaining: time,
                otpSent: time > 0
            };
        });
    };

    render() {
        const {
            phone,
            otpSent,
            otpVerified,
            loading,
            verifyingOtp,
            telegramId,
            otpExpirationTimeRemaining,
            showNumberModal
        } = this.state;

        return (
            <>
                <div className="tabContent-block">
                    <div className="email-template-wrap">
                        <div className="rightSectionHeader">
                            <div className="row justify-content-between align-items-center">
                                <div className="col-md-4 tab-right-header">
                                    <h6>Attack Profile</h6>
                                    <p>Create attacker profile</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-3">
                            {(phone && telegramId) ? (
                                <div className='inputNumber'>
                                    <PhoneInput disabled value={phone} country="in" />
                                    <p className='removeLink' style={{ cursor: 'pointer' }}
                                        onClick={() => this.setState({ phone: '', otpSent: false, otpVerified: false, telegramId: '' })}
                                    >Remove Number</p>
                                </div>
                            ) : (
                                <Button variant="primary" onClick={this.handleShow}>
                                    <AddSharpIcon className="btn-icon" /> Add Phone Number
                                </Button>
                            )}
                        </div>
                    </div>

                    <div className="mt-2">
                        <div className="footer-wrapper justify-content-end d-flex ft-padding">
                            <Button
                                variant="secondary"
                                className="mr-2"
                                onClick={() => this.props.handleTabChange('prev')}
                            >
                                <ArrowBackOutlinedIcon className="btn-icon" /> Previous
                            </Button>
                            <Button
                                variant="success"
                                disabled={!phone || loading || !telegramId}
                                onClick={() => this.handleCreateSender(telegramId)}
                                className="d-flex align-items-center"
                            >
                                {!loading && <ArrowForwardOutlinedIcon className="btn-icon mr-1" />} Go To Next
                            </Button>
                        </div>
                    </div>

                    {loading && <Loader />}
                </div>

                <Modal show={showNumberModal} onHide={this.numberhandleClose} className="commonModal">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h5>Add Phone Number</h5>
                            <p>Provide your sender's phone number</p>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Label>Mobile Number</Form.Label>
                        <PhoneInput
                            country="in"
                            value={phone}
                            disabled={otpSent}
                            onChange={phone => this.setState({ phone })}
                        />

                        {otpSent && !otpVerified && otpExpirationTimeRemaining > 0 && (
                            <div className="otpSection">
                                <div className="heading">
                                    <h6>Enter OTP</h6>
                                    <p className="text-muted">Enter the one-time password (OTP) sent to your Telegram application</p>
                                    <OTP handleOTP={this.handleOTP} />

                                    <div className="text-center">
                                        <small className="text-primary">
                                            Resend OTP in {
                                                <CountdownTimer
                                                    decreaseOtpExpirationTime={this.decreaseOtpExpirationTime}
                                                    seconds={otpExpirationTimeRemaining}
                                                    style={{ color: '#007bff', fontSize: '12px', display: 'inline' }}
                                                />
                                            }
                                        </small>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className="btn closeBtn" onClick={this.numberhandleClose}>
                            Cancel
                        </Button>
                        <Button
                            className="btn btn-success"
                            onClick={!otpSent ? this.handleRequestOTP : this.handleVerifyOTP}
                            disabled={loading || verifyingOtp}
                        >
                            {!otpSent ? (loading ? 'Sending OTP...' : 'Request OTP') : (verifyingOtp ? 'Verifying...' : 'Verify OTP')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}